<!--div class="card h-100">
  <a
    [routerLink]="['/liveinfo']"
    [queryParams]="{ liveId: this.liveInfo.liveId }">
    <img
      [src]="this.liveInfo.liveLogo"
      [style]="'background-color: ' + this.liveInfo.liveLogoBg + ';'"
      class="card-img-top">
    <div class="card-body">
      <h5 class="card-title">{{this.liveInfo.liveTitle}}</h5>
      <p class="card-text">{{this.liveInfo.liveSubtitle}}</p>
    </div>
  </a>
</div-->
<div class="card h-100">
  <div class="row g-0 h-100">
    <div 
      class="col-4 h-100 d-flex align-items-center"
      [style]="'background-color: ' + this.liveInfo.liveLogoBg + ';'">
      <img 
        [src]="this.liveInfo.liveLogo"
        height="300px"
        class="img-fluid rounded-start" alt="...">
    </div>
    <div class="col-8">
      <div class="card-body">
        <h5 class="card-title">{{this.liveInfo.liveTitle}}</h5>
        <p class="card-text">{{this.liveInfo.liveSubtitle}}</p>
      </div>
    </div>
  </div>
</div>
